<template>
  <v-container style="">
    <v-layout align-center row justify-center>
      <v-flex :class="getWidth">
        <v-footer style="background: transparent;" class="hidden-sm-and-down">
          <!-- START TABLET AND DESKTOP FOOTER -->
          <v-layout class="footer-links" align-center row justify-center>
            <v-flex sm5 class="text-md-left">
              <router-link to="/">
                <img src="@/assets/logo.png" style="height: 2rem">
              </router-link>
            </v-flex>
            <v-flex sm7 text-md-right>
              <v-card-text class="text-md-right pr-0" style="color: #3c454f;"> <!-- 2b0d61 -->
                ¿Tienes dudas? Ingresa al Centro de Ayuda
                <!-- <a href="https://admin.elmejorlugarparatrabajar.cl/" target="_blank">Módulo de Administración - </a>
                &copy;2019 -->
              </v-card-text>
            </v-flex> 
          </v-layout>
          <!-- END TABLET AND DESKTOP FOOTER -->
        </v-footer>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    icons: [
      {
        icon: "fab fa-facebook-f",
        link: "http://www.facebook.com/GrupoSecurity/"
      },
      {
        icon: "fab fa-twitter fa-2x",
        link: "http://twitter.com/grupo_security/"
      }
    ]
  }),
  computed: {
    getWidth() {
      if (window.innerWidth > 1366) {
        return "md12 px-0"
      } else {
        return "md10 px-4"
      }
    },
  },
};
</script>
<style scoped>
.footer-links a {
  text-decoration: none;
  color: #2b0d61 !important;
  line-height: 15px !important;
}

.footer-links p {
  font-family: "Titillium Web", "sans-serif";
  color: #2b0d61;
  line-height: 15px !important;
}

.footer-menu {
  font-family: "Titillium Web", "sans-serif";
  font-size: 14 !important;
  font-weight: 400;
}
.footer-menu-title {
  font-family: "Titillium Web", "sans-serif";
  font-size: 14 !important;
  font-weight: 700;
  color: #2b0d61;
}
.flex.xs3 {
  max-width: 22%;
}
.index-0 {
  background-color: #3c58a1;
}
.index-1 {
  background-color: #30abf6;
}

.container {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: unset;
  margin: auto;
  padding: 10px 24px;
  width: 100%;
  padding: 0;
}

/* Estilos para IE 11 */
@media all and (-ms-high-contrast:none){
  .container {
    margin-top: 5rem;
    background-color: transparent !important;
  }
}
</style>